import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

/**
 * A hook to retrieve the current theme.
 */
export const useTheme = () => {
  const { theme } = useContext(ThemeContext);

  return theme;
};
